export default __webpack_public_path__ + "static/media/@horintt.21c6c629.jpeg";